window.addEventListener('load', function(event) {
    let timeElapsed = 0;
    
    setInterval(() => {
        timeElapsed += 30;
        Shopify.analytics.publish("time_on_page", {
            minutes: timeElapsed / 60
        });
    }, 30000);
});